module.exports = SharedDependencies.React['@servicetitan/cpb-host'];